export default __webpack_public_path__ + "static/media/settings_payment_img.8ceb3f30.svg";